module.exports = __webpack_public_path__ + "dfc77fde79f7544fdf2878a325899dd5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/tractor.svg
// module id = 123
// module chunks = 0